exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MapPointer__pointer{width:21px;height:29px;position:absolute;-webkit-transform:translate(-50%,-100%);transform:translate(-50%,-100%)}", ""]);

// exports
exports.locals = {
	"pointer": "MapPointer__pointer"
};